<template>
  <div class="payment-create main-content">
    <div class="page-header">
      <h3 class="page-title">
        {{ $t("prepayments.view_po_prepayment") }}
      </h3>
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <router-link slot="item-title" to="/super-admin/dashboard">{{
            $t("general.home")
          }}</router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link slot="item-title" to="/super-admin/purchase-orders">{{
            $tc("navigation.pos", 2)
          }}</router-link>
        </li>

        <li class="breadcrumb-item">
          {{ $t("prepayments.view_po_prepayment") }}
        </li>
      </ol>
    </div>
    <SinglePurchaseOrderFinanceRow :fetchData="fetchData" />
    <SinglePrePaymentPOFinanceRequestRow
      :prepaymentRequest="prepaymentRequest"
    />
  </div>
</template>

<script>
import SinglePrePaymentPOFinanceRequestRow from "./SinglePrePaymentPOFinanceRequestRow";
import SinglePurchaseOrderFinanceRow from "./SinglePurchaseOrderFinanceRow.vue";

import { mapActions, mapGetters } from "vuex";
import MultiSelect from "vue-multiselect";
import { validationMixin } from "vuelidate";
import moment from "moment";
const {
  required,
  between,
  maxLength,
  numeric
} = require("vuelidate/lib/validators");

export default {
  components: {
    MultiSelect,
    SinglePrePaymentPOFinanceRequestRow,
    SinglePurchaseOrderFinanceRow
  },
  mixins: [validationMixin],
  data() {
    return {
      userType: null,
      fetchData: [],
      prepaymentRequest: [],
      isLoading: false
    };
  },
  created() {
    if (localStorage.getItem("role") == "super_admin") {
      this.userType = "super_admin";
    } else if (localStorage.getItem("account_type") == "anchor") {
      this.userType = "anchor";
    } else if (localStorage.getItem("account_type") == "supplier") {
      this.userType = "supplier";
    } else if (localStorage.getItem("account_type") == "funder") {
      this.userType = "funder";
    }
    this.loadInvoice();
    this.loadRequest();
  },
  validations() {
    return {};
  },
  computed: {},
  watch: {},
  async mounted() {
    this.$nextTick(() => {});
  },
  methods: {
    ...mapActions("po", ["SinglePOArray"]),
    ...mapActions("prepayment", [
      "fetchPOPrePaymentRequest",
      "fetchPrePayment"
    ]),
    async loadInvoice() {
      let response = await this.SinglePOArray(this.$route.params.id);
      if (response.data) {
        this.fetchData = response.data.purchaseOrder;
      }
    },
    async loadRequest() {
      if (this.$route.params.id) {
        let res = await this.fetchPOPrePaymentRequest(this.$route.params.id);
        if (res.data) {
          this.prepaymentRequest = res.data.pOPrepaymentRequest;
        }
      }
    }
  }
};
</script>
<style scoped>
.table-component {
  min-height: 0px;
}
</style>
